import React from 'react';
type SectionProps = {
  index: string;
  label: string;
  title: string;
  intro?: string;
  children: React.ReactNode;
};
export function Section({
  index,
  label,
  title,
  intro,
  children
}: SectionProps) {
  return <section className="border-b border-line" data-id="element-99" data-mp="kxfo0aw9wled">
      <div className="mx-auto max-w-5xl px-8 py-14 md:px-12 md:py-16" data-id="element-100" data-mp="ky7kdnxp2n5p">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent" data-id="element-101" data-mp="gwdn7pmpk1aa">
          {index} — {label}
        </p>
        <h2 className="mt-4 max-w-3xl text-2xl font-semibold tracking-tight text-white md:text-4xl" data-id="element-102" data-mp="1dmwc4wcv1g4s">
          {title}
        </h2>
        {intro && <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-white/55" data-id="element-103" data-mp="13u73saclwido">
            {intro}
          </p>}
        <div className="mt-10" data-id="element-104" data-mp="ztetdds007ft">{children}</div>
      </div>
    </section>;
}